import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosPagosPagoConfigurarPagadoraComponent {
  cuentas
  pagadora
  pago
  onSelect

  $onInit () {
    if (this.pago) {
      this.id_cuenta = this.pago.id_cuenta_retiro
      this.setCuenta()
    }
  }

  setCuenta () {
    this.onSelect({$event: {detail: this.id_cuenta}})
  }
}

module.component('viaticosPagosPagoConfigurarPagadora', {
  controller: ViaticosPagosPagoConfigurarPagadoraComponent,
  template,
  bindings: {
    pago: '<',
    pagadora: '<',
    cuentas: '<',
    onSelect: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/pagos/pago/configurar/pagadora/component.js